import React from 'react'
import { PasswordVerification } from '../Components'
import styled from '@emotion/styled'
import { useLogon } from '@core/Utils/hooks'
import { font, spacing } from '@mobi/component-library/Theme/Common'
import { useNavigate } from 'react-router'

import { MainContainer } from '@core/Components/Containers'

export const PasswordVerificationPage: React.FC = () => {
  const { accountNumber, isLoggedIn } = useLogon()
  const navigate = useNavigate()

  const handleVerify = () => {
    navigate('/account/settings/mfa/', { replace: true })
  }

  const handleCancel = () => {
    navigate('/account/settings')
  }

  return (
    <MainContainer data-tid-mfa-password-container>
      <PageContainer>
        <Header>Verify Password</Header>
        {isLoggedIn && accountNumber ? (
          <PasswordVerification
            onVerify={handleVerify}
            onCancel={handleCancel}
            accountNumber={accountNumber}
          />
        ) : (
          <p>Please Login</p>
        )}
      </PageContainer>
    </MainContainer>
  )
}

// ======
// Styles
// ======

const PageContainer = styled.section({
  padding: spacing.md,
})

const Header = styled.h1({
  fontFamily: font.family.primary,
  ...font.size.xl5,
  fontWeight: font.weight.semibold,
  marginBottom: spacing.md,
})
